import { render, staticRenderFns } from "./VPurchaseEntry.vue?vue&type=template&id=54f8ce42&scoped=true"
import script from "./VPurchaseEntry.vue?vue&type=script&lang=ts"
export * from "./VPurchaseEntry.vue?vue&type=script&lang=ts"
import style0 from "./VPurchaseEntry.vue?vue&type=style&index=0&id=54f8ce42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8ce42",
  null
  
)

export default component.exports